import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DLModal } from 'appSrc/components/Shards';
import { dAPI } from 'appSrc/api';
import ItemForm from './ItemForm';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';


class NewItemModal extends PureComponent {
    
    constructor(props) {
        super(props);

        this.state = {
            fetching: false,
        };
    }

    submitHandler = ( { item } ) => {
        this.setState( { fetching: true } );

        this.props.createItem( { ...item } )
        .then( ( newItem ) => {
            
            this.setState( { fetching: false } );
            this.props.onSubmit && this.props.onSubmit( newItem );
        
        } );
    }


    render() {
        const initialValues = { context: this.props.context };
        return (
            <DLModal title='New Item'
            closeHandler={ this.props.closeModal }>
                <div>
                    <ItemForm onSubmit={ this.submitHandler } initialValues={ initialValues } />
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }
}
const mapDispatchToProps = () => {
    return {
        createItem: ( data ) => {
            return dAPI.post( '/admin/homepage/hero', data );
        },
        updateItem: ( id, data ) => {
            return dAPI.patch( `/admin/homepage/hero/${ id }`, data );
        },
    };
};

export default connect( null, mapDispatchToProps )( NewItemModal );
